export default __webpack_public_path__ + "2abdaaf042f0068229db7adb5fa7ecfc.jpg";